export const setPermissionAction = () => {
  return async (dispatch) => {
    const role = localStorage.getItem("role") || "SuperUser";

    const isSuperUser = role === "SuperUser",
      isManager = role === "Manager",
      isOperator = role === "Operator",
      isCR = role === "CR",
      isHR = role === "HR",
      isAccountant = role === "Accountant";

    await dispatch({
      type: "SET_PERMISSION",
      payload: {
        // Global
        permission: role,
        isSuperUser,
        isManager,
        isCR,
        isHR,
        isOperator,
        isAccountant,
        // Canceling
        canceling_reason_create: isSuperUser || isManager,
        canceling_reason_delete: isSuperUser || isManager,
        // Categories
        service_category_create_update: isSuperUser || isManager,
        service_category_delete: isSuperUser || isManager,
        // Cities
        city_create_update: isSuperUser || isManager,
        city_delete: isSuperUser || isManager,
        province_create_update: isSuperUser || isManager,
        province_delete: isSuperUser || isManager,
        // Discount
        admin_discount_create_update:
          isSuperUser || isManager || isCR || isOperator,
        discountcoupon_create_update:
          isSuperUser || isManager || isCR || isOperator || isAccountant,
        discountcoupon_delete:
          isSuperUser || isManager || isCR || isOperator || isAccountant,
        used_discounts:
          isSuperUser || isManager || isCR || isOperator || isAccountant,
        use_discount_check: isSuperUser || isManager || isCR || isOperator,
        // Employers
        employer_create_update: isSuperUser || isManager,
        employer_delete: isSuperUser || isManager,
        employee_list: isSuperUser || isManager || isHR || isOperator,
        admin_user_employer_create:
          isSuperUser || isManager || isCR || isOperator,
        admin_user_employer_delete:
          isSuperUser || isManager || isCR || isOperator,
        entered_employee_code_list:
          isSuperUser || isManager || isCR || isOperator,
        // Failing Reason
        failing_reason_create: isSuperUser || isManager,
        failing_reason_delete: isSuperUser || isManager,
        failing_reason_update: isSuperUser || isManager,
        // Failure Request
        customer_satisfaction_create:
          isSuperUser || isManager || isHR || isOperator,
        customer_satisfaction_delete:
          isSuperUser || isManager || isHR || isOperator,
        customer_satisfaction_update:
          isSuperUser || isManager || isHR || isOperator,
        failure_request_create: isSuperUser || isManager || isHR || isOperator,
        failure_request_delete: isSuperUser || isManager || isHR || isOperator,
        failure_request_update: isSuperUser || isManager || isHR || isOperator,
        failure_request_items_create: isSuperUser || isManager,
        failure_request_items_delete: isSuperUser || isManager,
        failure_request_items_update: isSuperUser || isManager,
        // Invoices
        invoices_list:
          isSuperUser || isManager || isCR || isOperator || isAccountant,
        invoices_get:
          isSuperUser || isManager || isCR || isOperator || isAccountant,
        invoices_create: isSuperUser || isManager || isOperator,
        invoices_update: isSuperUser || isManager || isOperator,
        invoices_destroy: isSuperUser,
        invoices_send_invoice_to_client: isSuperUser || isManager || isOperator,
        compare_orders: isSuperUser || isManager || isAccountant,
        // KPI
        kpi_analysis: isSuperUser || isManager || isCR,
        // Order Admin
        admin_create_update: isSuperUser || isManager || isOperator,
        admin_delete: isSuperUser || isManager || isOperator,
        admin_log_create: isSuperUser || isManager || isOperator,
        // Order Personnel
        send_order_to_personnel: isSuperUser || isManager || isOperator,
        // Others
        run_shell_statistics: isSuperUser || isManager || isCR || isHR,
        // Payment Transactions
        payment_transactions_list:
          isSuperUser || isManager || isOperator || isAccountant,
        payment_transactions_get:
          isSuperUser || isManager || isOperator || isAccountant,
        payment_transactions_create: isSuperUser,
        payment_transactions_update: isSuperUser,
        payment_transactions_delete: isSuperUser,
        // Personnel
        personnel_get: isSuperUser || isManager || isHR || isOperator,
        personnel_create: isSuperUser || isManager || isHR || isOperator,
        personnel_update: isSuperUser || isManager || isHR || isOperator,
        personnel_destroy: isSuperUser || isManager,
        personnel_send_sms_to_personnel: isSuperUser || isManager || isOperator,
        // Return User
        return_user_create: isSuperUser || isManager,
        return_user_update: isSuperUser || isManager,
        return_user_destroy: isSuperUser || isManager,
        // Services
        moderator_create_update: isSuperUser || isManager,
        moderator_delete: isSuperUser || isManager,
        // Survey Item
        survey_item_create: isSuperUser || isManager,
        survey_item_delete: isSuperUser || isManager,
        // Users
        users_create: isSuperUser || isManager || isCR || isOperator,
        users_update: isSuperUser || isManager || isCR || isOperator,
        users_destroy: isSuperUser || isManager,
        // Violation
        violation_type_items_create: isSuperUser || isManager,
        violation_type_items_delete: isSuperUser || isManager,
        violation_result_items_create:
          isSuperUser || isManager || isHR || isOperator,
        violation_result_items_delete:
          isSuperUser || isManager || isHR || isOperator,
        violation_comments_create:
          isSuperUser || isManager || isHR || isOperator,
        violation_comments_delete:
          isSuperUser || isManager || isHR || isOperator,
        violation_solved_items_create:
          isSuperUser || isManager || isHR || isOperator,
        violation_solved_items_delete:
          isSuperUser || isManager || isHR || isOperator,
        // Wallet
        wallet_list: isSuperUser || isManager || isOperator || isAccountant,
        wallet_get: isSuperUser || isManager || isOperator || isAccountant,
        wallet_create: isSuperUser || isManager || isOperator,
        wallet_update: isSuperUser || isManager || isOperator,
        wallet_group_charge: isSuperUser || isManager,
        // SMS Template
        sms_messages_list: isSuperUser || isManager || isOperator || isHR,
        sms_messages_get: isSuperUser || isManager || isOperator || isHR,
        sms_messages_create: isSuperUser || isManager || isOperator || isHR,
        sms_messages_update: isSuperUser || isManager || isOperator || isHR,
        sms_messages_delete: isSuperUser || isManager || isOperator || isHR,
        // Admins
        admins_get: isSuperUser || isManager,
        // Rejection Reason
        rejection_reasons_create: isSuperUser || isManager,
        rejection_reasons_update: isSuperUser || isManager,
        rejection_reasons_delete: isSuperUser || isManager,
        // Recruitment
        recruitment_list: isSuperUser || isManager || isHR,
        recruitment_get: isSuperUser || isManager || isHR,
        recruitment_create: isSuperUser || isManager || isHR,
        recruitment_update: isSuperUser || isManager || isHR,
        recruitment_delete: isSuperUser,
        // Roulette
        roulette_items_list:
          isSuperUser ||
          isManager ||
          isOperator ||
          isCR ||
          isHR ||
          isAccountant,
        roulette_items_get:
          isSuperUser ||
          isManager ||
          isOperator ||
          isCR ||
          isHR ||
          isAccountant,
        roulette_items_create:
          isSuperUser ||
          isManager ||
          isOperator ||
          isCR ||
          isHR ||
          isAccountant,
        roulette_items_update:
          isSuperUser ||
          isManager ||
          isOperator ||
          isCR ||
          isHR ||
          isAccountant,
        roulette_items_delete:
          isSuperUser ||
          isManager ||
          isOperator ||
          isCR ||
          isHR ||
          isAccountant,
        roulette_results:
          isSuperUser ||
          isManager ||
          isOperator ||
          isCR ||
          isHR ||
          isAccountant,
      },
    });
  };
};

export const clearPermissionAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_PERMISSION", payload: {} });
  };
};
